// extracted by mini-css-extract-plugin
export default {"sidebar-container":"Sidebar_sidebar-container__zrkMM","sidebar-header":"Sidebar_sidebar-header__0cEGW","active":"Sidebar_active__LyIwh"};